import React, { useState, useEffect } from "react";
import dayjs from "dayjs";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
// Attempt to import user refresh action if it exists
// If getUsersByID does not exist in your slice, remove or adjust this import.
import { getUsersByID, getWheelPoint } from "../../store/slices/user"; // adjust if path differs

const bucketUrl = process.env.REACT_APP_IMAGE_URL || "https://space.kuga59.co/";

const SuccessToast = ({ message, show, onClose }) => {
  useEffect(() => {
    if (!show) return;
    const timer = setTimeout(onClose, 4000);
    return () => clearTimeout(timer);
  }, [show, onClose]);

  if (!show) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: "20px",
        right: "20px",
        backgroundColor: "#D1FAE5",
        border: "2px solid #10B981",
        borderRadius: "12px",
        padding: "16px 20px",
        maxWidth: "320px",
        boxShadow: "0 10px 25px rgba(0, 0, 0, 0.15)",
        zIndex: 10000,
        animation: "slideIn 0.3s ease-out",
        display: "flex",
        alignItems: "center",
        gap: "12px",
      }}
    >
      <span style={{ fontSize: "20px" }}>✅</span>
      <span style={{ color: "#065F46", fontWeight: "500", flex: 1 }}>
        {message}
      </span>
      <button
        onClick={onClose}
        style={{
          background: "none",
          border: "none",
          fontSize: "24px",
          cursor: "pointer",
          color: "#065F46",
          padding: "4px",
          marginLeft: "8px",
          borderRadius: "50%",
          width: "32px",
          height: "32px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          transition: "all 0.2s ease",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = "rgba(0, 0, 0, 0.1)";
          e.currentTarget.style.transform = "scale(1.1)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = "transparent";
          e.currentTarget.style.transform = "scale(1)";
        }}
      >
        ×
      </button>
      <style>
        {`
          @keyframes slideIn {
            from {
              transform: translateX(100%);
              opacity: 0;
            }
            to {
              transform: translateX(0);
              opacity: 1;
            }
          }
        `}
      </style>
    </div>
  );
};

const CounterBonus = () => {
  const dispatch = useDispatch();
  const { singleUsers } = useSelector((state) => state.user || {});
  const user = singleUsers && singleUsers.length ? singleUsers[0] : null;

  const [timeLeft, setTimeLeft] = useState("00:00:00");
  const [activeIcon, setActiveIcon] = useState(`${bucketUrl}3d-present.png`);
  const [enableClick, setEnableClick] = useState(false);
  const [toast, setToast] = useState({ show: false, message: "" });
  const giftPendingIcon = `${bucketUrl}3d-stopwatch.png`;
  const giftCloseIcon = `${bucketUrl}3d-present.png`;

  const showSuccessToast = (message) => setToast({ show: true, message });
  const hideToast = () => setToast({ show: false, message: "" });

  // Receive reward
  const handleReceive = async () => {
    if (!enableClick || !user?.id) return;
    setEnableClick(false);
    try {
      const res = await axios.post(
        `https://api.kuga59.co/countdownbox/receive/${user.id}`,
      );
      if (res?.data?.message === "Diamond Point Added Success") {
        // Refresh user data if action exists
        if (typeof getUsersByID === "function") {
          try {
            dispatch(getUsersByID(user));
            dispatch(getWheelPoint(user));
          } catch (_) {}
        }
        showSuccessToast("คุณได้รับเพชร!!!");
      } else {
        alert("ไม่สามารถรับเพชรได้กรุณาติดต่อแอดมิน");
      }
    } catch (e) {
      console.error(e);
      alert("ไม่สามารถรับเพชรได้กรุณาติดต่อแอดมิน");
    }
  };

  // Countdown logic
  useEffect(() => {
    if (!user?.countdown_end) {
      setTimeLeft("00:00:00");
      setEnableClick(false);
      setActiveIcon(giftCloseIcon);
      return;
    }

    const end = dayjs(user.countdown_end);
    if (!end.isValid()) {
      setTimeLeft("00:00:00");
      setEnableClick(false);
      setActiveIcon(giftCloseIcon);
      return;
    }

    const update = () => {
      const now = dayjs();
      const diff = end.diff(now);
      if (diff <= 0) {
        setTimeLeft("00:00:00");
        setEnableClick(true);
        setActiveIcon(giftCloseIcon);
        return;
      }
      // manual diff breakdown instead of dayjs.duration
      const totalSeconds = Math.floor(diff / 1000);
      const hours = String(Math.floor(totalSeconds / 3600)).padStart(2, "0");
      const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(
        2,
        "0",
      );
      const seconds = String(totalSeconds % 60).padStart(2, "0");
      setTimeLeft(`${hours}:${minutes}:${seconds}`);
      setEnableClick(false);
      setActiveIcon(giftPendingIcon);
    };

    update();
    const interval = setInterval(update, 1000);
    return () => clearInterval(interval);
  }, [user, giftCloseIcon, giftPendingIcon]);

  // Hidden if no user
  if (!user) return null;

  const themeColor = "#f97316"; // Orange theme color to match

  return (
    <div
      className="counterbonus-trigger-wrapper"
      style={{
        position: "fixed",
        top: "calc(42% - 100px)",
        right: 0,
        transform: "translateY(-50%)",
        zIndex: 1000,
        background:
          "linear-gradient(135deg, rgba(30, 30, 50, 0.95) 0%, rgba(20, 20, 35, 0.9) 100%)",
        backdropFilter: "blur(12px)",
        WebkitBackdropFilter: "blur(12px)",
        padding: "8px 6px 10px",
        borderTopLeftRadius: "14px",
        borderBottomLeftRadius: "14px",
        width: "62px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "6px",
        userSelect: "none",
        boxShadow:
          "0 8px 32px rgba(0, 0, 0, 0.4), 0 0 0 1px rgba(255, 255, 255, 0.08), inset 0 1px 0 rgba(255, 255, 255, 0.1)",
        transition:
          "transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1), box-shadow 0.3s ease",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "translateY(-50%) translateX(-4px)";
        e.currentTarget.style.boxShadow =
          "0 12px 40px rgba(0, 0, 0, 0.5), 0 0 0 1px rgba(255, 255, 255, 0.12), inset 0 1px 0 rgba(255, 255, 255, 0.15)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "translateY(-50%) translateX(0)";
        e.currentTarget.style.boxShadow =
          "0 8px 32px rgba(0, 0, 0, 0.4), 0 0 0 1px rgba(255, 255, 255, 0.08), inset 0 1px 0 rgba(255, 255, 255, 0.1)";
      }}
    >
      {/* Decorative glow */}
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "-20px",
          width: "40px",
          height: "60px",
          background: `radial-gradient(ellipse, ${themeColor}40 0%, transparent 70%)`,
          transform: "translateY(-50%)",
          pointerEvents: "none",
          filter: "blur(8px)",
        }}
      />

      <button
        onClick={handleReceive}
        disabled={!enableClick}
        aria-label="receive-bonus"
        style={{
          border: "none",
          background: "transparent",
          padding: 0,
          cursor: enableClick ? "pointer" : "not-allowed",
          opacity: enableClick ? 1 : 0.7,
          transition:
            "transform 0.25s cubic-bezier(0.34, 1.56, 0.64, 1), opacity 0.2s ease",
          position: "relative",
        }}
        onMouseEnter={(e) => {
          if (enableClick) {
            e.currentTarget.style.transform = "scale(1.08)";
          }
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = "scale(1)";
        }}
      >
        {/* Icon container with gradient border */}
        <div
          style={{
            position: "relative",
            width: "50px",
            height: "50px",
            borderRadius: "14px",
            background: enableClick
              ? `linear-gradient(145deg, ${themeColor}, ${themeColor}88)`
              : "linear-gradient(145deg, #6b7280, #4b5563)",
            padding: "3px",
            boxShadow: enableClick
              ? `0 4px 20px ${themeColor}40, 0 2px 8px rgba(0, 0, 0, 0.3)`
              : "0 4px 20px rgba(107, 114, 128, 0.3), 0 2px 8px rgba(0, 0, 0, 0.3)",
            transition: "all 0.3s ease",
          }}
        >
          <img
            src={activeIcon}
            alt="bonus-gift"
            draggable={false}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              borderRadius: "13px",
              display: "block",
              transition: "transform 0.3s ease",
              animation: enableClick
                ? "bonusBounce 1s ease-in-out infinite"
                : "none",
            }}
          />
          {/* Shine overlay */}
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              borderRadius: "16px",
              background:
                "linear-gradient(135deg, rgba(255,255,255,0.2) 0%, transparent 50%, transparent 100%)",
              pointerEvents: "none",
            }}
          />
        </div>

        {/* Ready indicator badge */}
        {enableClick && (
          <div
            style={{
              position: "absolute",
              top: "-4px",
              right: "-4px",
              width: "14px",
              height: "14px",
              borderRadius: "50%",
              background: "linear-gradient(135deg, #22c55e, #16a34a)",
              border: "2px solid rgba(20, 20, 35, 0.9)",
              boxShadow: "0 2px 8px rgba(34, 197, 94, 0.5)",
              animation: "bonusPulse 2s ease-in-out infinite",
            }}
          />
        )}
      </button>

      {/* Timer display */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "2px",
        }}
      >
        <span
          style={{
            fontSize: "0.8rem",
            fontWeight: 700,
            fontFamily: "monospace",
            color:
              timeLeft === "00:00:00" ? "#22c55e" : "rgba(255,255,255,0.95)",
            textAlign: "center",
            letterSpacing: "0.05em",
            textShadow:
              timeLeft === "00:00:00"
                ? "0 0 8px rgba(34, 197, 94, 0.6)"
                : "0 1px 4px rgba(0, 0, 0, 0.5)",
            animation:
              timeLeft === "00:00:00"
                ? "bonusBlink 1s ease-in-out infinite"
                : "none",
          }}
        >
          {timeLeft}
        </span>
      </div>

      <SuccessToast
        message={toast.message}
        show={toast.show}
        onClose={hideToast}
      />

      <style>
        {`
          @keyframes bonusPulse {
            0%, 100% { transform: scale(1); opacity: 1; }
            50% { transform: scale(1.15); opacity: 0.85; }
          }
          
          @keyframes bonusBounce {
            0%, 100% { transform: scale(1); }
            50% { transform: scale(1.05); }
          }
          
          @keyframes bonusBlink {
            0%, 100% { opacity: 1; }
            50% { opacity: 0.6; }
          }
          
          .counterbonus-trigger-wrapper::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            height: 1px;
            background: linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent);
            border-radius: 16px 16px 0 0;
          }
        `}
      </style>
    </div>
  );
};

export default CounterBonus;
